import React, { useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import parse from "html-react-parser";
import TitleBar from "../../../../partials/content/TitleBar";
import Sidebar from "../../../../partials/aside/Sidebar";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";
import httpService from "../../../../../services/httpServices/httpServices";
import SelectDropDown from "../../../../partials/content/SelectDropDown";

export default function Add() {
  const history = useHistory();

  const [userID, setUserID] = useState();
  const [users, setUsers] = useState([]);
  const [text, setText] = useState();

  useEffect(() => {
    getAllUser();
  }, []);

  const getAllUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let users = await sendRequestGetAllUser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    users = users.map((user) => {
      return {
        id: user.usr_id,
        firstname: user.firstname,
        lastname: user.lastname != undefined ? user.lastname : "",
      };
    });
    setUsers(users);
  };

  const sendRequestGetAllUser = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/all",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const apiKey = "n0pnn5k9s0m0dsdttkjemajjkwr2ud59f1m3kvan1f8skwc5";
  const pluginsTinyMCEEditor = "lists link";
  const toolBarTinyMCEEditor =
    " undo redo fontsize |  numlist bullist checklist link |  bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify lineheight | checklist  indent outdent |  ";

  const bodyStyleTinyMCEEditor = "body {direction: rtl}";

  const sendForm = async (e) => {
    e.preventDefault();
    if (!userID) {
      alert("لطفا کاربر را انتخاب کنید.");
      return;
    }
    e.preventDefault();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let result = await sendRequestAddPrivateNotification({
      text: text,
      title: document.querySelector("#title").value,
      user_id: userID + "",
    });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!result) {
      return;
    }
    history.push("/user/notification-private/all");
  };

  const sendRequestAddPrivateNotification = async (data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/private-notification/manage",
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateOptionTagUsers = (users) => {
    const usersForDropDown = users.map((user) => {
      const label = `
               شماره کاربر : ${helpersNumbers.toPersianNum(user.id)}
              -
             ${user.firstname} ${user.lastname}`;
      return { value: user.id, label: label };
    });

    return (
      <SelectDropDown
        data={usersForDropDown}
        setItemHandler={(newItemSelected) => {
          setUserID(newItemSelected.value);
        }}
      />
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن پیام های خصوصی کاربران" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="text-white"
                  to="/user/notification-private/all"
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>

              <form onSubmit={sendForm}>
                <div class="form-group">
                  <label>کاربر</label>
                  {generateOptionTagUsers(users)}
                </div>
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    placeholder="عنوان"
                    required
                  />
                </div>
                <div>
                  <h2>متن</h2>
                  <div className="form-group">
                    <Editor
                      apiKey={apiKey}
                      onEditorChange={(content) => {
                        setText(content);
                      }}
                      init={{
                        custom_undo_redo_levels: false,
                        height: 300,
                        menubar: false,
                        plugins: pluginsTinyMCEEditor,
                        toolbar: toolBarTinyMCEEditor,
                        content_style: bodyStyleTinyMCEEditor,
                        default_link_target: "_blank",
                      }}
                    />
                  </div>
                </div>

                <div>
                  <h2>پیش نمایش متن</h2>
                  <div>{text && parse(text)}</div>
                  <div>
                    <button className="btn btn-success">درج</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
